import styled, {css} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Button} from '@/components/ui/button/Button'

export const StyledCloseBannerButton = styled(Button)(
    ({theme: {palette}}) => css`
        margin-left: auto;

        & svg {
            color: ${palette.neutral['400']};
        }
    `
)

export const StyledProPhotosHeader = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        padding-top: ${spacing * 10}px;
        padding-bottom: ${spacing * 6}px;
    `
)

export const StyledProPhotosHeaderText = styled(Flexbox)(
    ({theme: {palette, typography}}) => css`
        & h1 {
            color: ${palette.neutral['900']};
            ${typography.textLg};
            font-weight: 500;
        }
        & p {
            color: ${palette.neutral['700']};
            ${typography.textMd};
        }
    `
)

export const StyledProPhotosLastUpdated = styled.span(
    ({theme: {palette, typography}}) => css`
        color: ${palette.neutral['900']};
        ${typography.textSm};

        & strong {
            font-weight: 500;
        }

        & span {
            ${typography.textXs};
            color: ${palette.neutral['700']};
        }
    `
)
